import { useEffect, ReactNode } from "react";
import { TonConnectButton } from "@tonconnect/ui-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../services/store";
import { UsergroupAddOutlined } from "@ant-design/icons";
import { Space } from "antd";
import { fetchWebPrice } from "../services/slices/webPriceSlice";
import { isTelegramMiniApp } from "../utils/platform";
import WalletHeaderButton from "../components/WalletHeaderButton";
import KredafiLogo from "../kredafi/KredafiLogo";
import { isLegacyWebtransferBrand, webTokenIcon } from "../utils/miniAppBrand";
import "./Page.css";

interface PageProps {
  children: ReactNode;
}

const Page: React.FC<PageProps> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const activeUsers = useSelector((state: RootState) => state.app.activeUsers);
  const { currentPrice } = useSelector((state: RootState) => state.webPrice);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchWebPrice());
  }, [location, dispatch]);

  return (
    <div className="page-container">
      <div>
        <div className="header-container">
          {/* В Telegram — прежний логотип Webtransfer: мини-апп в ребрендинг
              KredaFi не входил. На сайте и в PWA — локпап KredaFi. */}
          {isLegacyWebtransferBrand ? (
            <img
              src="/assets/logo.png"
              alt="Logo"
              width={136}
              style={{ cursor: "pointer", flexShrink: 0 }}
              onClick={() => navigate("/")}
            />
          ) : (
            <span style={{ flexShrink: 0, display: "inline-flex" }}>
              <KredafiLogo
                size={48}
                theme="light"
                onClick={() => navigate("/")}
              />
            </span>
          )}
          {/* В Telegram — родная кнопка TON Connect, как всегда. В браузере и PWA
              она подключала бы только TON, поэтому там кнопка со списком сетей. */}
          {isTelegramMiniApp ? <TonConnectButton /> : <WalletHeaderButton />}
        </div>

        {children}
      </div>

      <div className="footer-stats">
        <Space size={10}>
          <Space>
            <UsergroupAddOutlined className="stats-icon" />
            <span>{activeUsers}</span>
          </Space>
          <Space>
            <img src={webTokenIcon} alt="WEB" className="stats-icon" />
            <span>~${currentPrice ? parseFloat(currentPrice.toFixed(7)).toString() : "0.0000000"}</span>
          </Space>
        </Space>
      </div>
    </div>
  );
};

export default Page;
